export default __webpack_public_path__ + "static/media/tagbiz_icon_blue.4400530e.svg";